import { render, staticRenderFns } from "./my-upload-oss.vue?vue&type=template&id=010b62c6&scoped=true"
import script from "./my-upload-oss.vue?vue&type=script&lang=js"
export * from "./my-upload-oss.vue?vue&type=script&lang=js"
import style0 from "./my-upload-oss.vue?vue&type=style&index=0&id=010b62c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010b62c6",
  null
  
)

export default component.exports